import React, { useContext, useState } from "react";
import styled from "styled-components";
import { Icon, Spinner } from "components/common";
import { Button, Input } from "components/bootstrap";
import { ForwarderWizardContext } from "../ForwarderWizardProvider";
const StyledIcon = styled(Icon)`
  margin-right: 0.5em;
`;
const ForwarderSelectionList = ({ forwarders, onForwarderSelect }) => {
  const { setSelectedForwarder: setNextSelectedForwarder } = useContext(ForwarderWizardContext);
  const [selectedForwarder, setSelectedForwarder] = useState();
  const handleSelection = (event) => {
    const { value: id } = event.target;
    const forwarder = forwarders.find((f) => f.id === id);
    if (forwarder === void 0) {
      throw new Error("Selected Forwarder is not in the list of Forwarders.");
    }
    setSelectedForwarder(forwarder);
  };
  const handleForwarderSelect = (event) => {
    event.preventDefault();
    if (selectedForwarder) {
      setNextSelectedForwarder(selectedForwarder);
      onForwarderSelect(selectedForwarder);
    }
  };
  return /* @__PURE__ */ React.createElement("form", { onSubmit: handleForwarderSelect }, /* @__PURE__ */ React.createElement("div", null, forwarders.length === 0 ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(StyledIcon, { name: "info" }), " There are no new Forwarders to configure."), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Spinner, { text: "Looking for Forwarders..." }))) : /* @__PURE__ */ React.createElement(React.Fragment, null, forwarders.map((forwarder) => /* @__PURE__ */ React.createElement(
    Input,
    {
      key: forwarder.hostname,
      id: forwarder.id,
      type: "radio",
      name: "forwarder",
      value: forwarder.id,
      label: /* @__PURE__ */ React.createElement("span", null, forwarder.hostname, " ", /* @__PURE__ */ React.createElement("small", null, "(", forwarder.node_id, ")")),
      onChange: handleSelection
    }
  )), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Spinner, { text: "Looking for more Forwarders..." })))), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", disabled: selectedForwarder === void 0 }, "Configure selected Forwarder"));
};
export default ForwarderSelectionList;
